import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import blockStyles from '../styles/block.styles';
export default css `
  ${componentStyles}
  ${blockStyles}

/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
    container-type: inline-size;
  }

  .container {
    width: min(var(--p-container-width), 100% - 2 * var(--p-gap));
    margin-inline: auto;
  }

  :host([enable-search]) .container {
    width: 100%;
  }

  .header {
    max-width: var(--p-text-max-width);
    margin-bottom: var(--p-gap);
  }

  /**
--------------------------------------------------
* Text align
--------------------------------------------------
*/
  .header.text-align-center {
    text-align: center;
    margin-inline: auto;
  }

  .header.text-align-right {
    text-align: right;
    margin-left: auto;
  }

  /**
--------------------------------------------------
* Files wrap
--------------------------------------------------
*/
  .files-wrap {
    display: grid;
  }

  .layout-grid {
    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
    gap: var(--p-file-grid-gap, 20px);
  }
  .layout-grid-small {
    grid-template-columns: repeat(auto-fill, minmax(135px, 1fr));
    gap: var(--p-file-grid-small-gap, 10px);
  }

  .layout-list {
    border-top: 1px solid var(--p-border);
  }

  .layout-masonry {
    display: block;
    column-gap: var(--p-file-masonry-gap, 20px);
    columns: 3;
  }

  @container (max-width: 900px) {
    .layout-masonry {
      columns: 2;
      --p-file-masonry-gap: 10px;
    }
  }

  @container (max-width: 400px) {
    .layout-masonry {
      columns: 1;
      --p-file-masonry-gap: 5px;
    }
  }

  /**
--------------------------------------------------
* List header
--------------------------------------------------
*/
  .data-count-0 {
    --p-list-grid-template-columns: 50px minmax(60px, 1fr);
  }

  .data-count-1 {
    --p-list-grid-template-columns: 50px minmax(60px, 3fr) 1fr;
  }

  .data-count-2 {
    --p-list-grid-template-columns: 50px minmax(60px, 3fr) 1fr 1fr;
  }

  .data-count-3 {
    --p-list-grid-template-columns: 50px minmax(60px, 3fr) 1fr 1fr 1fr;
  }

  .files-list-header {
    display: grid;
    grid-template-columns: var(--p-list-grid-template-columns);
    gap: var(--p-file-list-gap, 10px);
    padding: var(--p-file-list-padding, 4px 10px);
    font-size: var(--p-file-list-header-font-size, 0.875rem);
    font-weight: var(--p-file-list-header-font-weight, bold);
  }

  .files-list-header-item:first-child {
    grid-column: span 2;
  }

  /**
--------------------------------------------------
* Empty message
--------------------------------------------------
*/
  .empty {
    font-family: var(--p-body-font);
    font-size: var(--p-body-font-size);
    font-weight: var(--p-body-font-weight);
    font-style: var(--p-body-font-style);
    line-height: var(--p-body-line-height);
    letter-spacing: var(--p-body-letter-spacing);
    color: var(--p-text-color);
    margin: 0;
    opacity: var(--p-text-meta-opacity);
  }

  /**
--------------------------------------------------
* Slotted content
--------------------------------------------------
*/
  slot[name='header']::slotted(p:last-of-type) {
    --p-p-margin-bottom: 0;
    --p-preamble-margin-bottom: 0;
  }
`;
